module.exports = __webpack_public_path__ + "img/logo.5eef4258.png";